<template>
  <div class="py-3">
    <div class="tertiary--text text-body-2">
      {{ 
        $t(
        'fleet_management.agents.create.labels.create_agent_form_speed_limit'
        )
      }}
    </div>
    <v-text-field
      id="idEventosLimite"
      v-model.number="speedLimit"
      dense
      filled
      min="10"
      max="250"
      :readonly="!editMode"
      hide-details="auto"
      :rules="speedRules"
      type="number"
      @input="speedEmit"
    ></v-text-field>
  </div>
</template>

<script>
import { i18n } from '@leapsight/portal'

export default {
  name: 'Speed Limit',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    dataProp: {
      type: Object
    }
  },
  components: {},
  data() {
    return {
      speedLimit: 0,
      speedRules: [
        v =>
          !!v ||
          i18n.t('fleet_management.agents.create.errors.speed_limit_empty'),
        v =>
          (v && v >= 10) ||
          i18n.t(
            'fleet_management.agents.create.errors.speed_limit_range_error'
          ),
        v =>
          (v && v <= 250) ||
          i18n.t(
            'fleet_management.agents.create.errors.speed_limit_range_error'
          )
      ]
    }
  },
  methods: {
    speedEmit() {
      this.$emit('speedEmit', this.speedLimit)
    }
  },

  computed: {},
  mounted() {
    this.$emit('speedEmit', this.speedLimit)
  },
  watch: {
    editMode() {
      if (this.editMode == false) {
        this.speedLimit = this.dataProp
      }
    }
  },
  created() {
    this.speedLimit = this.dataProp
  }
}
</script>

<style lang="scss" scoped></style>
